import i18nData from '@anm/i18n/i18nData';
import { FC } from 'react';

export type I18nHeadProps = {};

export const I18N_DATA_NAME = 'WAVE_I18N_DATA';

const I18nHead: FC<I18nHeadProps> = () => (
  <script id={I18N_DATA_NAME} type="application/json" dangerouslySetInnerHTML={{ __html: JSON.stringify(i18nData) }} />
);
export default I18nHead;
